// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.category-title {
    margin: 4px 20px 0;
    font-size: 20px;
    color: #515151
}

.template-cards-container {
    display: flex;
    /*height: fit-content;*/
    transition: height 600ms;
    flex-wrap: wrap;
    overflow: hidden;
}

.show-hide-button-container {
    display: flex;
    justify-content: flex-end;
}

.show-hide-button {
    width: 115px;
    display: flex;
    padding: 5px 10px;
    margin-right: 25px;
    border-radius: 6px;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.25);
    align-items: center;
    justify-content: space-between;
}

.show-hide-home-page {
    width: 115px;
    display: flex;
    cursor: pointer;
    padding: 5px 10px;
    margin-right: 50px;
    align-items: center;
    justify-content: space-between;
}

.show-hide-button:hover {
    cursor: pointer;
}

.show-hide-text {
    color: #212121;
    font-size: 16px;
}

@media screen and (min-width: 1600px) {
    .show-hide-button {
        margin-right: 30px;
    }
}

@media screen and (max-width: 600px) {
    .template-header {
        display: flex;
        width: 100%;
        overflow-x: scroll;
        border: 5px solid #ffffff;
    }

    .template-header::-webkit-scrollbar {
        display: none;
    }

    .template-header-button {
        padding: 6px 20px;
        display: inline-block;
        margin: 5px;
        white-space: nowrap;
        border-radius: 30px;
    }

    .category-title {
        margin: 10px 15px 0;
        font-size: 17px;
        text-align: left;
        font-weight: 600;
    }

    .category-title-container {
        display: flex;
        flex-flow: row;
    }

    .template-cards-container {
        height: auto;
        width: 100%;
    }

    .show-hide-button {
        width: 90px;
        margin-top: 7px;
        padding: 5px 10px;
        margin-right: 10px;
    }

    .show-hide-text {
        font-size: 14px;
    }
}`, "",{"version":3,"sources":["webpack://./src/app/dashboard/css/templates.css"],"names":[],"mappings":";AACA;IACI,kBAAkB;IAClB,eAAe;IACf;AACJ;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,wBAAwB;IACxB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,yCAAyC;IACzC,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI;QACI,kBAAkB;IACtB;AACJ;;AAEA;IACI;QACI,aAAa;QACb,WAAW;QACX,kBAAkB;QAClB,yBAAyB;IAC7B;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,iBAAiB;QACjB,qBAAqB;QACrB,WAAW;QACX,mBAAmB;QACnB,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;QACnB,eAAe;QACf,gBAAgB;QAChB,gBAAgB;IACpB;;IAEA;QACI,aAAa;QACb,cAAc;IAClB;;IAEA;QACI,YAAY;QACZ,WAAW;IACf;;IAEA;QACI,WAAW;QACX,eAAe;QACf,iBAAiB;QACjB,kBAAkB;IACtB;;IAEA;QACI,eAAe;IACnB;AACJ","sourcesContent":["\n.category-title {\n    margin: 4px 20px 0;\n    font-size: 20px;\n    color: #515151\n}\n\n.template-cards-container {\n    display: flex;\n    /*height: fit-content;*/\n    transition: height 600ms;\n    flex-wrap: wrap;\n    overflow: hidden;\n}\n\n.show-hide-button-container {\n    display: flex;\n    justify-content: flex-end;\n}\n\n.show-hide-button {\n    width: 115px;\n    display: flex;\n    padding: 5px 10px;\n    margin-right: 25px;\n    border-radius: 6px;\n    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.25);\n    align-items: center;\n    justify-content: space-between;\n}\n\n.show-hide-home-page {\n    width: 115px;\n    display: flex;\n    cursor: pointer;\n    padding: 5px 10px;\n    margin-right: 50px;\n    align-items: center;\n    justify-content: space-between;\n}\n\n.show-hide-button:hover {\n    cursor: pointer;\n}\n\n.show-hide-text {\n    color: #212121;\n    font-size: 16px;\n}\n\n@media screen and (min-width: 1600px) {\n    .show-hide-button {\n        margin-right: 30px;\n    }\n}\n\n@media screen and (max-width: 600px) {\n    .template-header {\n        display: flex;\n        width: 100%;\n        overflow-x: scroll;\n        border: 5px solid #ffffff;\n    }\n\n    .template-header::-webkit-scrollbar {\n        display: none;\n    }\n\n    .template-header-button {\n        padding: 6px 20px;\n        display: inline-block;\n        margin: 5px;\n        white-space: nowrap;\n        border-radius: 30px;\n    }\n\n    .category-title {\n        margin: 10px 15px 0;\n        font-size: 17px;\n        text-align: left;\n        font-weight: 600;\n    }\n\n    .category-title-container {\n        display: flex;\n        flex-flow: row;\n    }\n\n    .template-cards-container {\n        height: auto;\n        width: 100%;\n    }\n\n    .show-hide-button {\n        width: 90px;\n        margin-top: 7px;\n        padding: 5px 10px;\n        margin-right: 10px;\n    }\n\n    .show-hide-text {\n        font-size: 14px;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
